import { createAction } from '@reduxjs/toolkit';
import { AppThunkDispatch, ILegalEntityDTO, IPersonDto } from '@qwealth/qdata';
import { DocusignTaxQuestionnaire } from 'data/models/DocusignTaxQuestionnaire';

const SET_CLIENT = 'SET_CLIENT';
const SET_CLIENT_TAX_FORMS = 'SET_CLIENT_TAX_FORMS';
const SET_SELECTED_CLIENT_TAX_FORM = 'SET_SELECTED_CLIENT_TAX_FORM';
const SET_CLIENT_TAX_FORM_SEND_RECEIVE_DATES = 'SET_CLIENT_TAX_FORM_SEND_RECEIVE_DATES';

export interface TaxQuestionnaireSendReceiveDates {
  taxQuestionnaireSendDate: string;
  taxQuestionnaireReceiveDate: string;
}

export const setProfileSelectedClient = createAction<IPersonDto | ILegalEntityDTO | undefined>(SET_CLIENT);
export const setClientTaxForms = createAction<DocusignTaxQuestionnaire[]>(SET_CLIENT_TAX_FORMS);
export const setSelectedClientTaxForm = createAction<DocusignTaxQuestionnaire>(SET_SELECTED_CLIENT_TAX_FORM);
export const setClientTaxFormSendReceiveDates = createAction<TaxQuestionnaireSendReceiveDates>(SET_CLIENT_TAX_FORM_SEND_RECEIVE_DATES);

export const setProfileSectionSelectedClient = (client: IPersonDto | ILegalEntityDTO | undefined) => (dispatch: AppThunkDispatch) => {
  dispatch(setProfileSelectedClient(client));
};

export const setTaxProfileClientTaxForms = (taxForms: DocusignTaxQuestionnaire[]) => (dispatch: AppThunkDispatch) => {
  dispatch(setClientTaxForms(taxForms));
};

export const setTaxProfileSelectedClientTaxForm = (taxForm: DocusignTaxQuestionnaire) => (dispatch: AppThunkDispatch) => {
  dispatch(setSelectedClientTaxForm(taxForm));
};

export const setTaxProfileSendReceiveTaxFormDates = (taxEnvelopeDates: TaxQuestionnaireSendReceiveDates) => (dispatch: AppThunkDispatch) => {
  dispatch(setClientTaxFormSendReceiveDates(taxEnvelopeDates));
};
